export default __webpack_public_path__ + "static/media/image@3x.eb4681f2.jpg";